export const calculateOverUnderStats = (
  matches: any[],
  isHome?: boolean,
  threshold: number = 2.5,
  isHalfTime: boolean = false
) => {
  const totalMatches = matches.length;
  let overCount = 0;
  let underCount = 0;

  matches.forEach(match => {
    let matchGoals = 0;

    if (isHome === true) {
      matchGoals = isHalfTime ? (parseInt(match.HTHG) || 0) : (parseInt(match.FTHG) || 0);
    } else if (isHome === false) {
      matchGoals = isHalfTime ? (parseInt(match.HTAG) || 0) : (parseInt(match.FTAG) || 0);
    } else {
      const homeGoals = isHalfTime ? (parseInt(match.HTHG) || 0) : (parseInt(match.FTHG) || 0);
      const awayGoals = isHalfTime ? (parseInt(match.HTAG) || 0) : (parseInt(match.FTAG) || 0);
      matchGoals = homeGoals + awayGoals;
    }

    if (matchGoals > threshold) {
      overCount++;
    } else {
      underCount++;
    }
  });

  const overPercentage = ((overCount / totalMatches) * 100).toFixed(1);
  const underPercentage = ((underCount / totalMatches) * 100).toFixed(1);

  return {
    overPercentage,
    underPercentage
  };
};

export const calculateMatchResults = (matches: any[]) => {
  const totalMatches = matches.length;
  let homeWins = 0;
  let awayWins = 0;
  let draws = 0;

  matches.forEach(match => {
    if (match.FTR === 'H') homeWins++;
    else if (match.FTR === 'A') awayWins++;
    else draws++;
  });

  const homeWinPercentage = ((homeWins / totalMatches) * 100).toFixed(1);
  const awayWinPercentage = ((awayWins / totalMatches) * 100).toFixed(1);
  const drawPercentage = ((draws / totalMatches) * 100).toFixed(1);

  return {
    homeWinPercentage,
    awayWinPercentage,
    drawPercentage
  };
};

export const calculateFoulsStats = (matches: any[]) => {
  const totalMatches = matches.length;
  let homeFouls = 0;
  let awayFouls = 0;

  matches.forEach(match => {
    homeFouls += parseInt(match.HF) || 0;
    awayFouls += parseInt(match.AF) || 0;
  });

  const totalFouls = homeFouls + awayFouls;
  const averageFoulsPerMatch = (totalFouls / totalMatches).toFixed(2);

  return {
    averageFoulsPerMatch
  };
};

export const calculateHtFtStats = (matches: any[]) => {
  const totalMatches = matches.length;
  const stats = {
    htWinFtWin: 0,
    htWinFtDraw: 0,
    htWinFtLose: 0,
    htDrawFtWin: 0,
    htDrawFtDraw: 0,
    htDrawFtLose: 0,
    htLoseFtWin: 0,
    htLoseFtDraw: 0,
    htLoseFtLose: 0,
    comebackWins: 0
  };

  matches.forEach(match => {
    const htResult = match.HTR;
    const ftResult = match.FTR;

    if (htResult === 'H' && ftResult === 'H') stats.htWinFtWin++;
    else if (htResult === 'H' && ftResult === 'D') stats.htWinFtDraw++;
    else if (htResult === 'H' && ftResult === 'A') stats.htWinFtLose++;
    else if (htResult === 'D' && ftResult === 'H') stats.htDrawFtWin++;
    else if (htResult === 'D' && ftResult === 'D') stats.htDrawFtDraw++;
    else if (htResult === 'D' && ftResult === 'A') stats.htDrawFtLose++;
    else if (htResult === 'A' && ftResult === 'H') stats.htLoseFtWin++;
    else if (htResult === 'A' && ftResult === 'D') stats.htLoseFtDraw++;
    else if (htResult === 'A' && ftResult === 'A') stats.htLoseFtLose++;

    if ((htResult === 'A' && ftResult === 'H') || (htResult === 'A' && ftResult === 'D') ||
        (htResult === 'D' && ftResult === 'H')) {
      stats.comebackWins++;
    }
  });

  // Convert to numbers instead of strings for percentages
  const convertedStats: Record<string, number> = {};
  Object.keys(stats).forEach(key => {
    convertedStats[key] = Number(((stats[key as keyof typeof stats] / totalMatches) * 100).toFixed(1));
  });

  return convertedStats;
};
